<template>
    <div>
        <component :is="style" type="text/css">
        :root {
            --primary: {{primaryColor}};
            --primary-rgb: {{hexToRgb}};
            --text-color: {{textColor}};
            --shadow-color: {{shadowColor}}
        }
        </component>

        <div class="section hero ">
        <div class="columns" >
            <div class="column is-half title-column">
                <h1 class="is-title is-size-2-mobile is-size-2-tablet is-size-1-desktop  main-title">
                    {{basicHero.title}}
                </h1>
                <p class=" is-size-6-mobile is-size-5-tablet m-t-10">
                        {{basicHero.text}}
                    </p>
                    
                    <a
                    v-if="basicHero.buttonText && basicHero.buttonLink"
                    class="button is-custom is-medium m-t-10"
                    :href="basicHero.buttonLink">
                        {{basicHero.buttonText}}
                    </a>
                    
            </div> 
            <div class="column is-half img-column">
                <img :src="basicHero.image" alt="basic-landing-image">
            </div>
        </div>

    </div>

    </div>
</template>

<script>
import { getHandler } from '../../../services/http'
export default {
    props:{
        dataUrl:{
            type:String,
            default:""
        },
        primaryColor:{
            type:String,
            defualt:""
        },
        blackText:{
            type:String,
            defualt:""
        },
    },
    computed:{
        isFixed(){
            return localStorage.getItem('isfixed')
        },
        hexToRgb() {
            let hex = this.primaryColor
            var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
            hex = hex.replace(shorthandRegex, function(m, r, g, b) {
                return r + r + g + g + b + b;
            });

            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? `
                ${parseInt(result[1], 16)},
                ${parseInt(result[2], 16)},
                ${parseInt(result[3], 16)}
            ` : null;
            },
        textColor(){
            if(this.blackText=="True"){
                return 'black'
            } return 'white'
        },
        shadowColor(){
            if(this.basicHero.shadowImage){
                return this.primaryColor
            } return 'transparent'
        }
    },
    data(){
        return{
            basicHero:{},
            style:"style"
        }
    },
    methods:{
        async fetchBasicInfo(){
            this.basicHero = await getHandler(this.dataUrl, {error:false, success:false})
        }
    },
    created(){
        this.fetchBasicInfo()
    },

}
</script>

<style lang="scss" scoped>
@import "./../../../scss/my_vars.scss";
.hero{
    padding-left:8rem;
    padding-right:8rem;
    padding-top:3rem;
    @media (max-width: 1023px) {
        padding-left:2.5rem;
        padding-right:2.5rem;
        padding-top:4rem;
    }
    @media(max-width:769px){
        padding-top:3rem;
    }
}

.main-title{
    font-weight: 1000;
}

.title-column{
    h1{
        box-shadow: -30px 0px 0px 0px var(--primary);
    }
    
}

.img-column {
    img{
        box-shadow: 30px -30px 0px 0px var(--shadow-color);
        @media(max-width:769px){
            box-shadow: 40px 20px 0px 0px var(--shadow-color);
        } 
    }
    @media(max-width:769px){

        margin-top: 25px;
    }
   
}

.is-custom{
    color: var(--text-color);
    background-color:var(--primary);
}


</style>
